import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

const swiper = new Swiper('.slider-deals', {
    lazy: true,
    breakpoints: {
        "0": {
            slidesPerView: "auto",
            loop: false,
            spaceBetween: 0,
            slidesPerGroup: 1
        },
        "768": {
            slidesPerView: "auto",
            loop: false,
            spaceBetween: 0,
            slidesPerGroup: 2
        },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});